import { clamp01 } from './scale';

export type ProgressBarProps = {
  /** 0–1. */
  value: number;
  /** Sem cor = dourado do pacote. */
  color?: string;
  /** Nome acessível (ex.: "3 de 10 parcelas pagas"). */
  label: string;
  /** Estilo extra do trilho (ex.: `marginTop: 0` na tabela de parcelas). */
  flush?: boolean;
};

/** Barra de progresso (`.meter`). */
export function ProgressBar({ value, color, label, flush }: ProgressBarProps) {
  const pct = Math.round(clamp01(value) * 100);
  return (
    <div className="meter" style={flush ? { marginTop: 0 } : undefined} role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct}>
      <i style={color ? { width: `${pct}%`, background: color } : { width: `${pct}%` }} />
    </div>
  );
}
